import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { FC, useCallback, useEffect, useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";
import { TFraudRule } from "./types";

export const S_FRAUD_RULE_POPUP = new Signal<Record<string, number> | null>("S_FRAUD_RULE_POPUP");

export const FraudRulePopup: FC = () => {
	useLocale();
	const requestData = S_FRAUD_RULE_POPUP.use();
	const [rule, setRule] = useState<TFraudRule | null>(null);
	const [ruleMetaData, setRuleMetaData] = useState<{ id: number } | null>(null);

	useEffect(() => {
		if (!requestData) {
			setRule(null);
			return;
		}
		GD.REQ_FRAUD_RULE_GET.request({ ruleID: requestData.ruleID }).then(res => {
			setRule(res ? (res.data as TFraudRule) : null);
			setRuleMetaData(res ? { id: res.id } : null);
		});
	}, [requestData, setRule]);

	const closePopup = useCallback(() => {
		S_FRAUD_RULE_POPUP.invoke(null);
	}, []);

	if (!(requestData && rule)) return null;

	return (
		<Panel
			sx={{
				minWidth: "800px",
				maxWidth: "900px",
				height: "85vh",
			}}
			decorator="absolute"
			label={msg("createFraudRule")}
			onClose={closePopup}>
			<Box sx={{ height: "100%", overflow: "hidden", display: "flex", flexDirection: "column" }}>
				<FormParser
					previewMode={!!requestData.previewMode}
					scrollable
					onSubmit={async data => {
						await GD.REQ_FRAUD_RULE_SET.request({ ruleID: ruleMetaData!.id, data });
						return data;
					}}
					onRequest={async () => {
						return rule;
					}}
					sx={{ height: "100%" }}
				/>
			</Box>
		</Panel>
	);
};
